import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  Button,
  ColorSvg,
  HContainer,
  HContainerV,
  Text
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

export const ButtonLink = (props) => {

  return (

    <HContainerV
      margin={props.margin}>

      <Button
        onClick={props.onClick}
        maxWidth={props.maxWidth}
        height={props.height}
        activeColor={CustomColors.Black}
        activeBorderColor={CustomColors.Transparent}
        activeBackgroundColor={CustomColors.Transparent}>

        <HContainer alignItems={'center'} >
          <Text
            fontSize={props.fontSize}
            fontFamily={props.fontFamily}
            fontWeight={props.fontWeight}
            lineHeight={props.lineHeight}
            margin={'0 5px 0 5px'}
            color={props.color}>

            {`${props.text} `}
          </Text>

          <ColorSvg
            width={'12px'}
            height={'12px'}
            color={props.backgroundColor}
            src={props.iconSrc}/>
        </HContainer>

      </Button>
    </HContainerV>
  );
};

ButtonLink.propTypes = {
  margin: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
  maxWidth: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string,
  lineHeight: PropTypes.string,
  iconSrc: PropTypes.string,
  backgroundColor: PropTypes.string
};

ButtonLink.defaultProps = {
  margin: '0px',
  text: 'Back',
  height: '0vw',
  lineHeight: '24px',
  maxWidth: '54px',
  fontSize: '16px',
  fontWeight: '500',
  fontFamily: 'Roboto',
  color: '#fff',
  iconSrc: `${Icons.ForwardArrow}`,
  backgroundColor:'#fff'
};